import { render, staticRenderFns } from "./position.vue?vue&type=template&id=fcaf67fe&scoped=true&"
import script from "./position.vue?vue&type=script&lang=ts&"
export * from "./position.vue?vue&type=script&lang=ts&"
import style0 from "./position.vue?vue&type=style&index=0&id=fcaf67fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaf67fe",
  null
  
)

export default component.exports